module.exports = __webpack_public_path__ + "static/flexibilidade-tooltip-8c2bbe4381c928b1ec4bbfaef24762b4.svg";